import { render, staticRenderFns } from "./product-group-list.vue?vue&type=template&id=c53d2bcc&scoped=true&"
import script from "./product-group-list.vue?vue&type=script&lang=js&"
export * from "./product-group-list.vue?vue&type=script&lang=js&"
import style0 from "./product-group-list.vue?vue&type=style&index=0&id=c53d2bcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53d2bcc",
  null
  
)

export default component.exports